var map = {
	"./Error.vue": [
		9669,
		669
	],
	"./Home.vue": [
		2046,
		46
	],
	"./Profile.vue": [
		9329,
		329
	],
	"./Statistic.vue": [
		3403,
		403
	],
	"./notFoundUser.vue": [
		3040,
		40
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;